import { SessionHandler } from "./SessionHandler.js";

export class RepeatingIrrigationAPI {
    /**
     * Gets a list of all commands for all zones in JSON form
     * @return {Promise<Array>}
     * @constructor
     */
    static async GetAll() {
        let response = await SessionHandler.doFetch("schedule/", { method: "GET" });
        return (await response.json()).irrigations;
    }

    /**
     * Adds a command to the specified zone based on the parameters.
     * @param {Object<string, number>} zoneWateringPercentages
     * @param {String} rrule string version of RRule
     * @param {int} duration duration in millieseconds
     * @param {string} group
     * @return {Promise<any>}
     *
     */
    static async addOne(zoneWateringPercentages, duration, rrule, group, zoneIrrigationOffsets, options) {
        let response = await SessionHandler.doFetch("schedule/", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            redirect: "follow",
            body: JSON.stringify({
                zonesActive: Object.keys(zoneWateringPercentages),
                zoneWateringPercentages: zoneWateringPercentages,
                zoneIrrigationOffsets: zoneIrrigationOffsets,
                duration: duration,
                rrule: rrule,
                commandGroup: group,
                ...options,
            }),
        });
        return await response.json();
    }

    /**
     * Edits a command to change the specified parameters

     * @param {string} irrigationEventID
     * @param {Object<string, number>} zoneWateringPercentages
     * @param {String} rrule string version of RRule
     * @param {int} duration duration in millieseconds
     * @return {Promise<any>}
     */
    static async editOne(
        irrigationEventID,
        zoneWateringPercentages = undefined,
        duration = undefined,
        rrule = undefined,
        zoneIrrigationOffsets = undefined,
    ) {
        let response = await SessionHandler.doFetch("schedule/" + irrigationEventID, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "PATCH",
            redirect: "follow",
            body: JSON.stringify({
                zonesActive: Object.keys(zoneWateringPercentages),
                zoneWateringPercentages: zoneWateringPercentages,
                zoneIrrigationOffsets: zoneIrrigationOffsets,
                duration: duration,
                rrule: rrule,
            }),
        });
        return await response.json();
    }

    /**
     * deletes a command
     * @param {string} commandID
     * @return {Promise<Boolean>}
     */
    static async deleteOne(commandID) {
        let response = await SessionHandler.doFetch("schedule/" + commandID, {
            headers: {},
            method: "DELETE",
            redirect: "follow",
        });
        if (response.ok) {
            return true;
        } else {
            throw new Error("Not Deleted");
        }
    }
}
